import * as exJson from '../../json';

// ----------------------------------------------------------------------------

function getResponse(xhr: XMLHttpRequest): Record<string, any> | undefined {
    let data = xhr.response;

    if (typeof data === 'string') {
        const parsed = exJson.parse(data);

        if (parsed !== null) {
            (xhr as any).responseJSON = parsed;
            data = parsed;
        }
    }

    return data;
}

// ----------------------------------------------------------------------------

export default getResponse;
